import timezonesList from 'timezones-list';

interface TimezoneItem {
  tzCode: string;
  label: string;
  name: string;
  utc: string;
}

export interface TimezoneOption {
  value: string;
  label: string;
}

/**
 * Get timezone options formatted for Select component
 * Returns IANA timezone codes with user-friendly labels
 */
export function getTimezoneOptions(): TimezoneOption[] {
  const list = timezonesList as TimezoneItem[];
  return list.map((tz: TimezoneItem) => ({
    value: tz.tzCode,
    label: tz.label,
  }));
}

/**
 * Get a timezone option by IANA timezone code
 */
export function getTimezoneOption(tzCode: string): TimezoneOption | undefined {
  const list = timezonesList as TimezoneItem[];
  const tz = list.find((t: TimezoneItem) => t.tzCode === tzCode);
  if (!tz) return;
  return {
    value: tz.tzCode,
    label: tz.label,
  };
}

export function getNowInTimeZone(timeZone?: string | null): Date {
  const now = new Date();
  if (!timeZone) return now;

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const parts = formatter.formatToParts(now);
    const get = (type: Intl.DateTimeFormatPartTypes) =>
      Number(parts.find((p) => p.type === type)?.value ?? '0');

    const year = get('year');
    const month = get('month');
    const day = get('day');
    const hour = get('hour');
    const minute = get('minute');
    const second = get('second');

    return new Date(year, month - 1, day, hour, minute, second);
  } catch {
    return now;
  }
}

